import PoaPdfLogo from '@/assets/PoaPdfLogo';
import Survey from '@/components/survey';
import { INode, IWaitingListRecord } from '@/components/survey/SurveyModel/types/nodeTypes';
import dayjs from 'dayjs';
import React  from 'react';

export interface PoaSurveyPdfProps {
   questionnaireDetails: INode;
   waitingListRecord: IWaitingListRecord;
}

const PoaSurveyPrintContent = React.forwardRef<HTMLDivElement, PoaSurveyPdfProps>(
    ({ questionnaireDetails, waitingListRecord }, ref) => {
        const val = (value: string | number | null | undefined) => value || '--';
        const capitalizeFirstLetter = (value: string | null | undefined) =>
            value ? `${value.charAt(0).toUpperCase()}${value.slice(1)}` : '--';

        return (
            <div className='pdf-theme' ref={ref}>
                <div className='report-container'>
                    <div className='header-container'>
                        <div className='header-cell'>
                            <div className='patient-summary-container'>
                                <div className='patient-summary'>
                                    <span className='text'>Pre-operative assessment: {val(waitingListRecord.teamReviewOutcome?.replace(/"/g, ''))}</span>
                                    <span className='text'>{val(waitingListRecord.forename)}, {val(waitingListRecord.surname)}</span>
                                    <span className='text'>CHI: {val(waitingListRecord.chiNumber)}</span>
                                </div>
                                <div className='logo'><PoaPdfLogo /></div>
                            </div>
                            <div className='patient-info-container'>
                                {/* Row 1 */}
                                <div className='patient-info-cell'>
                                    <span className='label'>DOB</span>
                                    <span className='value'>{waitingListRecord.dob ? dayjs(waitingListRecord.dob).format('DD/MM/YY') : '--'}</span>
                                </div>
                                <div className='patient-info-cell'>
                                    <span className='label'>Age</span>
                                    <span className='value'>{val(waitingListRecord.age)}</span>
                                </div>
                                <div className='patient-info-cell'>
                                    <span className='label'>Sex</span>
                                    <span className='value'>{capitalizeFirstLetter(waitingListRecord.sex)}</span>
                                </div>
                                <div className='patient-info-cell'>
                                    <span className='label'>POA outcome</span>
                                    <span className='value'>{val(waitingListRecord.teamReviewOutcome?.replace(/"/g, ''))}</span>
                                </div>
                                <div className='patient-info-cell'>
                                    <span className='label'>POA expiry</span>
                                    <span className='value'>{waitingListRecord.expirationDateTime ? dayjs(waitingListRecord.expirationDateTime).format('DD/MM/YY') : '--'}</span>
                                </div>
                                {/* Row 2 */}
                                <div className='patient-info-cell'>
                                    <span className='label'>Surgeon</span>
                                    <span className='value'>{val(waitingListRecord.surgeon)}</span>
                                </div>
                                <div className='patient-info-cell'>
                                    <span className='label'>Speciality</span>
                                    <span className='value'>{val(waitingListRecord.speciality)}</span>
                                </div>
                                <div className='patient-info-cell'>
                                    <span className='label'>Hospital</span>
                                    <span className='value'>{val(waitingListRecord.hospitalName)}</span>
                                </div>
                                <div className='patient-info-cell'>
                                    <span className='label'>Scheduled</span>
                                    <span>{waitingListRecord.operationDate ? dayjs(waitingListRecord.operationDate).format('DD/MM/YY') : '--'}</span>
                                </div>
                                <div className='patient-info-cell'>
                                    <span className='label'>TTG</span>
                                    <span className='value'>{waitingListRecord.treatmentTimeGuaranteeDate ? dayjs(waitingListRecord.treatmentTimeGuaranteeDate).format('DD/MM/YY') : '--'}</span>
                                </div>
                                {/* Row 3 */}
                                <div className='patient-info-cell col-span-2'>
                                    <span className='label'>OPCS-4/operation</span>
                                    <span className='value'>{val(waitingListRecord.operationProcedure)}</span>
                                </div>
                                <div className='patient-info-cell'>
                                    <span className='label'>Priority</span>
                                    <span className='value'>{val(waitingListRecord.priority)}</span>
                                </div>
                                <div className='patient-info-cell'>
                                    <span className='label'>Anae.</span>
                                    <span className='value'>{val(waitingListRecord.anaestheticType)}</span>
                                </div>
                                <div className='patient-info-cell'>
                                    <span className='label'>IP/DSU</span>
                                    <span className='value'>{val(waitingListRecord.intendedManagementReferenceCode)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='form-container'>
                        <div className='form-content'>
                            <Survey
                                disabled={false}
                                config={questionnaireDetails}
                            ></Survey>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
);

PoaSurveyPrintContent.displayName = 'PoaSurveyPrintContent';

export default PoaSurveyPrintContent;
